import { getModuleFederatedName, setupServiceInfo } from '@estee/elc-universal-utils';
import { ServiceManager } from '@estee/elc-service';
import serviceNames, { StoresService } from '~setup/StoresService';
import {
    STORES_DIRECTORY,
    STORES,
    STORE_DETAILS,
    PICK_UP_IN_STORE,
    FIND_IN_STORE_MODAL,
    FIND_IN_STORE_BUTTON,
    BUY_ONLINE_PICKUP_IN_STORE_MODAL,
    STORE_NOTIFICATION
} from '@estee/elc-service-view-names';
import { serviceBusBaseClass } from './service-setup/ServiceBus';

setupServiceInfo(__serviceInfo__);

const { name, version } = __serviceInfo__;

StoresService.setViews(name, getModuleFederatedName(name), version, [
    STORES_DIRECTORY,
    STORES,
    STORE_DETAILS,
    PICK_UP_IN_STORE,
    FIND_IN_STORE_MODAL,
    FIND_IN_STORE_BUTTON,
    BUY_ONLINE_PICKUP_IN_STORE_MODAL,
    STORE_NOTIFICATION
]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('~setup/diContainer'),
    serviceKey: serviceNames.storesService,
    serviceBusControllerKey: serviceNames.serviceBusController,
    serviceBus: { serviceBusBaseClass }
});
